/* eslint-disable react/no-unknown-property */
import {
  AvatarSkeleton, Card, TextSkeleton, TypographyName,
} from '@doveit/bricks';
import React from 'react';
import * as styles from './ViewEntityPreviewSkeleton.style';
import useIsDevice from '../../hooks/use-is-device/useIsDevice';

export type ViewEntityPreviewSkeletonProps = React.AriaAttributes & {
  hideHeader?: boolean
};

const ViewEntityPreviewSkeleton: React.FC<ViewEntityPreviewSkeletonProps> = ({
  hideHeader = false,
  ...rest
}) => {
  const isMobile = useIsDevice('mobile');

  return (
    <Card {...rest}>
      {!hideHeader && (
        <Card.Header>
          <TextSkeleton width="8rem" typography={TypographyName.HEADING_4} />
        </Card.Header>
      )}
      <Card.Content>
        <div css={styles.basic}>
          <div css={styles.info}>
            <AvatarSkeleton size={isMobile ? 'M' : 'L'} />
            <div css={styles.textInfo}>
              <div>
                <TextSkeleton count={2} mainWordsInLine={1} />
              </div>
            </div>
          </div>
          {isMobile && (<Card.Divider />)}
          <div css={styles.detailsWrapper}>
            <div css={styles.details}>
              <div>
                <TextSkeleton
                  count={2}
                  mainWordsInLine={1}
                  typography={TypographyName.CAPTION}
                  width="7.5rem"
                />
              </div>
              <div>
                <TextSkeleton
                  count={2}
                  mainWordsInLine={1}
                  typography={TypographyName.CAPTION}
                  width="7.5rem"
                />
              </div>
              <div>
                <TextSkeleton
                  count={2}
                  mainWordsInLine={1}
                  typography={TypographyName.CAPTION}
                  width="7.5rem"
                />
              </div>
            </div>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default ViewEntityPreviewSkeleton;
